type SetDefinition = Models.SetsPlayground.SetDefinition;
type ContentPropertyType = Models.SetsPlayground.ContentPropertyType;

export const DESIGN_CONCEPT_FILTER_KEY: ContentPropertyType = 'DesignConceptId';

// ASP only holds inline ranked designs back for the set's slots when the set is exclusive AND
// filtered to those same concepts. Exclusive without the filter swallows the entire gallery.
// The tool sets exclusive for nothing else, so the flag is what marks the filter as ours to remove.
export const syncInlineRankingExclusivity = (set: SetDefinition): SetDefinition => {
    // The seasonal set has no ranking and owns its exclusive flag.
    if (!set.ranking) {
        return set;
    }

    const { exclusive, ...setWithoutExclusive } = set;
    const { [DESIGN_CONCEPT_FILTER_KEY]: leftoverFilter, ...otherContent } = set.filters?.content ?? {};

    if (set.ranking.type === 'inline' && set.ranking.designConceptIds.length > 0) {
        return {
            ...set,
            exclusive: true,
            filters: {
                ...set.filters,
                content: { ...otherContent, [DESIGN_CONCEPT_FILTER_KEY]: [...set.ranking.designConceptIds] },
            },
        };
    }

    if (!exclusive) {
        return set;
    }

    if (!set.filters?.content) {
        return setWithoutExclusive;
    }

    return {
        ...setWithoutExclusive,
        filters: { ...set.filters, content: otherContent },
    };
};
